import { Box, IconButton, styled, Typography } from "@mui/material";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

interface ActionCardProps {
    cardType: string,
    title: string,
    description: string,
    onClick?: () => void,
}

const StyledCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'cardType',
})<{ cardType: string }>(({ cardType }) => ({
  backgroundColor: cardType === 'technology' ? 'var(--Interviewer-Black)' : '#fff',
  borderRadius: '12px',
  padding: '24px',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  border: '1px solid var(--Light-Gray)',
  height: '100%',
}));

const CustomButtonStyle = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'cardType',
})<{ cardType: string }>(({ cardType }) => ({
  border:
    cardType === 'technology'
      ? '1px solid #FFFFFF26'
      : '1px solid var(--Interviewer-Lighter-Black)',
  borderRadius: '8px',
  width: '40px',
  height: '40px',
}));


const ActionCard = ({cardType, title, description, onClick}: ActionCardProps) => {
    return (
        <StyledCard cardType={cardType} onClick={onClick}
        >
            <CustomButtonStyle cardType={cardType}>
                <DashboardOutlinedIcon
                    sx={{
                        color: cardType === 'technology' ? '#fff' : 'var(--Interviewer-Lighter-Black)',
                    }}
                />
            </CustomButtonStyle>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <Typography 
                    variant="h6" 
                    fontWeight="bold"
                    sx={{ color: cardType === 'technology' ? '#fff' : 'var(--Interviewer-Black)' }}
                >
                    {title}
                </Typography>
                <Typography 
                    variant="body2"
                    sx={{ color: cardType === 'technology' ? '#fff' : 'var(--Interviewer-Lighter-Black)' }}
                >
                    {description}
                </Typography>
            </Box>
        </StyledCard>
    )
}
export default ActionCard;